export const environment = {
    APPLICATION_NAME: "Visible Speech",
    LOGO_IMAGE_PATH: "/assets/VISP-logo-white.png",
    API_ENDPOINT: "visp.humlab.umu.se",
    EMUDB_INTEGRATION: true,
    ENABLED_APPLICATIONS: ["jupyter", "artic", "tratt", "script"],
    BASE_DOMAIN: "visp.humlab.umu.se",
    GITLAB_API_ENDPOINT: "https://gitlab.visp.humlab.umu.se/api/v4",
    GITLAB_PERSONAL_ACCESS_TOKEN: null,
    ACCESS_LIST_ENABLED: true,
    PROJECT_MANAGER_FORCE_LOADING: false,
    PROTOCOL: "https",
    production: true
  };
